import React from "react";
import { useNavigate } from "react-router-dom";
import { Package, PackageX } from "lucide-react";
import { Card, ModernCardHeader } from "../../../components/cards";
import { Loading } from "../../../components/loading";
import { EmptyList } from "../../../components/empty-list";
import { useProducts } from "../../products/hooks";

const LOW_STOCK_THRESHOLD = 5;

export const StockAlertWidget: React.FC = () => {
  const navigate = useNavigate();
  const { data, loading } = useProducts({ where: {}, limit: 200, offset: 0 });

  const products = [...(data?.products?.results ?? [])].sort(
    (a, b) => (a.totalStock ?? 0) - (b.totalStock ?? 0)
  );

  return (
    <Card>
      <ModernCardHeader
        title="État des stocks"
        subtitle="Tous les produits, alertes en premier"
        action={
          <span
            className="text-xs text-indigo-600 cursor-pointer hover:underline"
            onClick={() => navigate("/products")}
          >
            Voir tout
          </span>
        }
      />
      {loading ? (
        <Loading />
      ) : !products.length ? (
        <EmptyList text="Aucun produit" />
      ) : (
        <div className="space-y-1 mt-3">
          {products.slice(0, 6).map((product) => (
            <div
              key={`stock-alert-${product.id}`}
              className="flex items-center justify-between gap-2 p-2 rounded-md hover:bg-gray-50 cursor-pointer border border-transparent hover:border-gray-200"
              onClick={() => navigate(`/product/${product.id}`)}
            >
              <div className="flex items-center gap-2 min-w-0">
                <div
                  className={`p-1.5 rounded-md flex-shrink-0 ${
                    (product.totalStock ?? 0) === 0
                      ? "bg-red-50 text-red-600"
                      : (product.totalStock ?? 0) <= LOW_STOCK_THRESHOLD
                      ? "bg-amber-50 text-amber-600"
                      : "bg-green-50 text-green-600"
                  }`}
                >
                  {(product.totalStock ?? 0) <= LOW_STOCK_THRESHOLD ? (
                    <PackageX className="w-4 h-4" />
                  ) : (
                    <Package className="w-4 h-4" />
                  )}
                </div>
                <span className="text-sm text-gray-900 truncate">{product.name}</span>
              </div>
              <span
                className={`text-xs font-semibold whitespace-nowrap ${
                  (product.totalStock ?? 0) === 0
                    ? "text-red-600"
                    : (product.totalStock ?? 0) <= LOW_STOCK_THRESHOLD
                    ? "text-amber-600"
                    : "text-green-600"
                }`}
              >
                {product.totalStock ?? 0} en stock
              </span>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
};
